export default "__VITE_ASSET__Ch7bTC1q__"